import ColorButtonWithTooltip from 'components/antd/ToolTip/ColorButtonWithTooltip'
import withMoreColorPick from 'components/comm/hoc/withMoreColorPick'

export const ButtonWithColorPick = withMoreColorPick(ColorButtonWithTooltip)
